import { uniq } from 'lodash';
import ascii2mathml from 'ascii2mathml';

function formatToAsciiMath(asciiMathEquation) {
  return `\`${asciiMathEquation}\``;
}

function getParameters(equation) {
  const mathMl = ascii2mathml(equation);

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(mathMl, 'text/xml');

  const htmlCollection = xmlDoc.getElementsByTagName('mi');
  const parameters = [...htmlCollection].map(
    (identifierTag) => identifierTag.innerHTML
  );

  return uniq(parameters).sort();
}

export default {
  formatToAsciiMath,
  getParameters,
};
